import { ItemSeparator, MenuItemGroup, MenuItemOption } from '@/types/menu.types';

export const isGroup = (item: MenuItemGroup | MenuItemOption | ItemSeparator | undefined): item is MenuItemGroup => {
  return item !== undefined && 'type' in item && item.type === 'group';
};

export const isSeparator = (
  item: MenuItemGroup | MenuItemOption | ItemSeparator | undefined,
): item is ItemSeparator => {
  return item !== undefined && 'type' in item && item.type === 'separator';
};
